import React from 'react'

class UrlInput extends React.Component{
	

	
	render() {
			let valueQR = this.props.valueQR;			
			let formId = this.props.formId;
			let isVisiableQR = this.props.isVisiableQR;
			let valueUrl = '<img src="https://sbqr.ru/qr/api_png_QR_text.php?qrtext=' + encodeURIComponent(valueQR) + '&id_form=' + formId + '" />';
            			
		
		
		if (isVisiableQR === false) 
			  { return null;
			  }
		else { return(
				<div className="embed-field">
				  <label className="embed-field__label" htmlFor="HTML_url">Скопируйте HTML-код для вставки QR-кода в Ваш сайт</label>
				   <textarea
						className="embed-field__input"
						id="HTML_url"
						name="HTML_url" 
						defaultValue={valueUrl}
						readOnly
						rows={3}
						spellCheck={false}
						aria-readonly="true"
				   />
				   
				</div>
				
				)
		}
	}
}
export default UrlInput
